import request from "@/router/axios";

export const getList = (params) => {
  return request({
    url: "/api/produce/rtk-electronic-fence-event/select/page",
    method: "get",
    params,
  });
};
